import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchCompanyCatalogSummary({ payload }) {
  try {
    const res = yield call(API.fetchCompanyCatalogSummary, payload);
    const { data } = res;
    yield put(actions.fetchCompanyCatalogSummarySuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyCatalogSummaryFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* companyCatalogListingSaga() {
  yield takeLatest(
    actions.fetchCompanyCatalogSummary.type,
    handleFetchCompanyCatalogSummary
  );
}
